import React, {useEffect, useState, useRef} from 'react'
import propTypes from 'prop-types'
import {Grid, Box, ButtonBase} from '@mui/material';
import styled from '@emotion/styled';
import { gql } from '@apollo/client';
import {get, findIndex, debounce, floor} from 'lodash';
import { makeStyles } from '@mui/styles';
import Text from '../../components/typography';
import {theme} from '../../themes/default-theme';
import TabsCurved from '../../components/ui/TabsCurved';
import ResponsiveImage from '../../components/ui/RespImg';
import toPrice from '../../util/toPrice';
import inViewport from '../../util/inViewport'

import { Cta } from '../../components/ui';
import NextLink from '../../components/navigation/NextLink';
import IconLink from '../../components/ui/IconLink';
import calculatorSvg from '../../assets/icons/calculator.svg';
import brochuresSvg from '../../assets/icons/brochures.svg';
import floorplanAdult from '../../assets/icons/floorplanAdult.svg';
import floorplanChild from '../../assets/icons/floorplanChild.svg';
import { ReactSVG } from 'react-svg';
import plusSvg from '../../assets/icons/plus-white.svg';
import Modal from '../../components/ui/Modal';
import SpecsTable from '../../components/content/SpecsTable';
import jaycoClient from '../../../src/graphql/jaycoClient';
import getModelDataQuery from '../../../src/graphql/queries/models-floor-plan/model-data';
import calculateRepayment from '../../../src/util/calculateRepayment';
import qs from 'qs';
import ReactHtmlParser from 'react-html-parser';
import getPriceKey from '../../util/getPriceKey';
import PostcodePopup from '../../components/ui/SimplePostcodePopup';
import CalculatorBannerModal from '../../components/multimedia/CalculatorBannerModal';

const Container = styled.div`
    h2 {
        max-width: 815px;
        margin-left: auto;
        margin-right: auto;
        ${theme.breakpoints.up("md")} {
            font-size: 34px;
        }
    }

    hr {
        ${props => props.background === 'black' ? `
            border-top-color: #555555;
        ` : ''}
    }
`

const Hr = styled.hr`

    border-top: 1px solid ${theme.palette.middleGrey};
    border-bottom: 0;
    border-left: 0;
    border-right: 0;

    ${props => props.medium && `
        ${theme.breakpoints.down('sm')} {
            display: none;
        }
    `}

`

const TabsContainer = styled.div`
    margin-top: 20px;
    ${theme.breakpoints.up("md")} {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 30px;
        margin-bottom: 20px;
    }
`

const TabItem = styled.div`
    ${theme.breakpoints.up("md")} {
        padding: 0 20px 20px;
    }
    div, button {
        overflow: visible!important;
    }
    p {
        margin-bottom: 10px;
        margin-top: 0;
    }
`

const FloorplanContainer = styled.div`
    max-width: 1200px;
    margin: 50px auto 0;
    

    ${theme.breakpoints.up("md")} {

    }

    h4 {
        letter-spacing: 0;
    }
`

const FloorplanImg = styled.div`
    max-width: 745px;
`

const FloorplanContent = styled.div`

    h4 {
        margin-bottom: 20px;
    }

    sup {
        font-size: 16px;
        margin-left: 5px;
        font-weight: 500;
    }

    hr {
        margin: 23px 0;
    }

    ${theme.breakpoints.up("md")} {
        max-width: 375px;
        float: right;
        width: 100%;

        h4 {
            margin-bottom: 25px;
        }
    }

    ${theme.breakpoints.down("sm")} {
        padding-top: 25px;

        h4,
        .MuiTypography-root {
            text-align: center;
        }
    }
`

const CtaLink = styled.div`
    margin-bottom: 20px;
    margin-top: 20px;
    ${theme.breakpoints.up("md")} {
        margin-top: 0;
        margin-bottom: 30px;
        button {
            min-width: 323px;
        }
    }

    ${theme.breakpoints.down("sm")} {
        width: 100%;
        a,
        button {
            width: 100%!important;
            display: block!important;
        }
    }
`

const Link = styled.div`
    margin: 18px 0;
`

const Floorplans = styled.div`
    display: flex;
    margin-bottom: 15px;
    overflow: auto;
    padding-left: 16px;
    padding-top: 17px;
    

    ${theme.breakpoints.down('sm')} {
        padding-left: 16px;
        padding-top: 13px;
        ${props => props.length === 1 && `
            justify-content: center;
        `}
    }
`

const FloorplanConfiguration = styled(ButtonBase)`
    width: auto;
    min-width: 114px;
    max-width: 140px;
    padding: 10px;
    border-radius: 6px; 
    margin-right: 8px;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    justify-content: flex-start;

    ${props => props.badge && `
        &:before {
            content: "${props.badge}";
            position: absolute;
            background: #00AEEF;
            color: #fff;
            line-height: 14px;
            width: 100%;
            left: 0;
            text-align: center;
            ${theme.breakpoints.up("md")} {
                top: -16px;
                padding: 2px 4px;
                border-radius: 6px 6px 0px 0px;
                font-size: 11px;
                text-transform: uppercase;
                font-weight: 700;
                min-width: 43px;
            }
            ${theme.breakpoints.down("sm")} {
                top: -12px;
                padding: 1px;
                border-radius: 4px 4px 0px 0px;
                font-size: 7px;
                text-transform: uppercase;
                font-weight: 700;
                min-width: 24px;
            }
         }
    `}
    ${props => (props.background && props.background === 'grey' && !props.active && props.colourTheme && props.colourTheme === 'light') ? 
            `
                background-color: transparent;
                border: 1px solid #758094;
                color: #758094;
                svg {
                    [fill] {
                        fill: #758094;
                    }
                }
            `
        : 
            'background-color: #292929;'
    }

    ${props => (props.background && props.background === 'grey' && !props.active && props.colourTheme && props.colourTheme === 'dark') && `
        border: 1px solid #525559;
    `}
    

    ${props => props.active && `
        background-color: ${theme.palette.vividBlue};
        border: 1px solid ${theme.palette.vividBlue};
    `}

    ${theme.breakpoints.down("sm")} {
        min-width: auto;
    }
    
`

const FloorplanConfigurationIcons = styled.div`
    ${theme.breakpoints.down("sm")} {
        white-space: nowrap;
    }
`

const FloorplanConfigurationText = styled.div`
    color: white;
    line-height: 14px;
    strong {
        font-size: 14px;
    }
    ${props => (props.background === 'grey' && !props.active && props.theme === 'light') &&
    `
        color: ${theme.palette.charcoal};
    `}

    p {
        margin: 0;
        font-size: 12px;
        line-height: 14px;
    }
`

const Adults = styled.div`
    display: inline-block;
    // margin-right: 5px;
`

const Adult = styled.div`
    display: inline-block;
    margin-right: 5px;
`

const Children = styled.div`
    display: inline-block;
    ${props => (props.background === 'grey' && !props.active && props.theme === 'light') ? 
        `
            svg {
                [fill] {
                    fill: #6CD1F6;
                }
            }
        `
        : 
        ''
    }
`

const Child = styled.div`
    display: inline-block;
    margin-right: 2px;

    ${props => props.opacity && `
        opacity: 0.5; 
    `}
`

const Plus = styled.span`
    display: inline-block;
    vertical-align: middle;
    color: white;
    position: relative;
    top: -5px;
`

const FloorplansText = styled(Text)`
    padding-bottom: 22px;
    ${props => props.small && `
        font-size: 14px!important;

        ${theme.breakpoints.down("sm")} {
            font-size: 12px!important;
        }
    `}

    ${theme.breakpoints.down("sm")} {
        padding-bottom: 9px;
        text-align: center;
    }
`
const FloorplansDiscalimer = styled(Text)`
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    ${theme.breakpoints.down("sm")} {
        text-align: center;
    }
`

const SpecsFeatures = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    
    ${props => props.odd && `
        > div:last-child {
            ${theme.breakpoints.up("md")} {
                min-width: 100%;
                width: 100%;
            }
        }
    `}

    ${props => props.colour === 'white' ? `
        color: white;
    ` : 
        `color: ${theme.palette.charcoal};`
    }

    ${theme.breakpoints.up("md")} {
        font-size: 16px;
    }
`

const SpecsFeaturesItem = styled.div`
    display: flex;
    color: inherit;
    border-top: 1px solid ${theme.palette.middleGrey};
    padding: 10px 0;
    width: 100%;
    font-size: 14px;

    ${props => props.background === 'black' ? `
        border-top-color: #555555;
    ` : ''}

    ${theme.breakpoints.up("md")} {
        min-width: 50%;
        max-width: 50%;
        padding: 5px 0;
        font-size: 16px;
    }
`

const SpecsFeaturesTitle = styled.div`
    min-width: 180px;
    max-width: 180px;
    padding-right: 20px;
`

const SpecsFeaturesValue = styled.div`
    width: 100%;
    padding-right: 20px;
`

const Specs = styled.div`
    margin: 40px 0 0;

    h6 {
        margin-bottom: 20px;
    }

    ${theme.breakpoints.up("md")} {
        margin: 50px 0;
    }
`

const Container360 = styled.div`
    margin-top: 80px;

    ${theme.breakpoints.up("md")} {
        margin-top: 120px;
    }
`

const Container360Titles = styled.div`

`

const IFrameContainer = styled.div`
    height: 0;
    padding-top: 53%;
    position: relative;
    margin-top: 40px;

    iframe {
        border: none;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
    
`

const CtaContainer = styled.div`
    ${props => props.colorTheme == 'dark' && `

        button {
            color: white !important;
            border: 2px solid white !important;
            &:hover {
                filter: brightness(80%);
            }
        }
    `} 
    ${theme.breakpoints.up("md")} {
        max-width: 283px;
    }
    ${theme.breakpoints.down("sm")} {
        > a, > button {
            width: auto;
        }
    }
`
const FloorplanImage = styled.div`
    ${theme.breakpoints.up("md")} {
        margin-bottom: 21px;
    } 
    ${theme.breakpoints.down("sm")} {
        margin-bottom: 24px;
    }
`
const FloorplanImageImg = styled.div`
    ${theme.breakpoints.up("md")} {
        max-width: 159px;
    }   
    ${theme.breakpoints.down("sm")} {
        max-width: 146px;
        align-self: center;
        margin-top: -20px;
    }
`

const CalculatorLink = styled.div`
    margin-top: 30px;

    ${theme.breakpoints.down("sm")} {
        margin-top: 40px;
        text-align: center;
    }
`

const useStyles = makeStyles({
    modalInner: {
      maxWidth: 1220,
      margin: '0 auto',
      display: 'inline-block',
      position: 'relative',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        maxWidth: 1320,
        paddingLeft: 50,
        paddingRight: 50
      }
    },
    modalClose: {
        top: '5px',
        right: '5px',
        left: 'auto',
        transform: 'none',
        position: 'absolute',
        
        '& button': {
            background: '#0170D4'
        }
    }
})

const Floorplan = (props) => {
    props = {
        ...props,
        colourTheme: typeof props.colourTheme === "undefined" ? 'light' : props.colourTheme,
        type: typeof props.type === "undefined" ? 'caravan' : props.type,
        link360PreTitle: typeof props.link360PreTitle === "undefined" ? null : props.link360PreTitle,
        link360Title: typeof props.link360Title === "undefined" ? null : props.link360Title,
        countryProps: typeof props.countryProps === "undefined" ? null : props.countryProps
    };

    const {
        preTitle,
        title,
        models,
        floorplans,
        uri,
        // floorplan,
        // financePerWeek,
        cta,
        financeLink,
        brochureLink,
        specsFeatures,
        colourTheme,
        background,
        rangeId,
        seriesId,
        link360PreTitle,
        link360Title,
        calculatorModal,
        countryProps
    } = props;

    console.log('FP props', props);

    const [activeModel, setActiveModel] = useState(models[0]);
    const [activeModelIndex, setActiveModelIndex] = useState(0);
    const [price, updatePrice] = useState(null);
    const [financePerWeek, setFinancePerWeek] = useState(0);
    const [pricingKey, setPricingKey] = useState(null);
    const [pricingModal, setPricingModal] = useState(false);
    const [calcBannerModal, setCalcBannerModal] = useState(false);
    const [priceLoading, setPriceLoading] = useState(true);

    const [floorplan, setFloorplan] = useState(models[0]?.floorplans[0]?.floorplan);
    const [activeFloorplanIndex, setActiveFloorplanIndex] = useState(0);
    const [iframeInView, setIframeInView] = useState(false);

    const iframeRef = useRef();

    const listener = (e) => {
        const show = inViewport(iframeRef.current, 500);
        if (show === true) {
            setIframeInView(true)
        }
    };

    useEffect(() => {
        listener();
        const delay = 200;
        window.addEventListener('scroll', debounce(listener, delay));
        return () => {
          window.removeEventListener('scroll', listener);
        };
      }, [])


    const [activeConfiguration, setActiveConfiguration] = useState(get(models, '[0].floorplans[0].floorplan.configurations[0]', {}));

    const [modal, openModal] = useState(false);

    const handleLaunchModal = (e) => {
        if (e) {
            e.preventDefault();
        }
        console.log('launch modal', e);
        openModal(true);
    }

    console.log('Floorplan props:', {props});

    const mainFontColour = colourTheme === 'light' ? 'charcoal' : 'white'

    useEffect(() => {

        const getData = async () => {
        //   setLoading(true);
        setPriceLoading(true);
    
          const GET_MODEL_DATA = gql`
            ${getModelDataQuery}
          `
    
          const result = (floorplan && floorplan.floorplanId) ? await jaycoClient.query({
            query: GET_MODEL_DATA,
            variables: {
              id: floorplan.floorplanId
            }
          }) : {};
          
    
            // Check location
            const key = pricingKey ? pricingKey : getPriceKey();

            // Populate these items to specs
            if (key) {
                const priceVal = result.data && result.data.getModel ? result.data.getModel[key] : 0; // get(result, `data.getModel[${pricingKey}]`, null);
                console.log('priceValpriceVal', priceVal);
                updatePrice(priceVal);
            } else {
                setPricingModal(true);
            }
        
            setTimeout(() => {
                // stop flicker
                setPriceLoading(false);
            }, 100)
    
        //   setLoading(false);
        }

        if (floorplan && floorplan.hidePrice !== true) {
            getData();
        } else {
            updatePrice(0);
        }

    }, [floorplan, pricingKey]);

    const classes = useStyles();

    useEffect(() => {
        if (props.rates) {
            const repayment = calculateRepayment({
                rates: props.rates,
                paymentFrequency: 52,
                price: (price + (activeConfiguration.additionalPrice ? parseInt(activeConfiguration.additionalPrice) : 0))
            });
            
            setFinancePerWeek(repayment);
        }

    },[price, activeConfiguration]);

    const ref = useRef(null)

    const getStyle = (oElm, strCssRule) => {
        var strValue = "";
        if(document.defaultView && document.defaultView.getComputedStyle){
            strValue = document.defaultView.getComputedStyle(oElm, "").getPropertyValue(strCssRule);
        }
        else if(oElm.currentStyle){
            strCssRule = strCssRule.replace(/\-(\w)/g, function (strMatch, p1){
                return p1.toUpperCase();
            });
            strValue = oElm.currentStyle[strCssRule];
        }
        return strValue;
    }

    useEffect(() => {
        const qsData = qs.parse(window.location.search.replace('?', ''));
    
        if (qsData && qsData.floorplan) {
            var activeModel;
            var modelIndex = 0;
            var floorplanIndex = 0;
            
            props.models.forEach((model, i) => {
                activeModel = model.floorplans.find((floorplan, j) => {
                    if (get(floorplan, 'floorplan.title', '').toLowerCase() === qsData.floorplan.toLowerCase()) {
                        floorplanIndex = j;
                        return true
                    }
                });
                if (activeModel) {
                    modelIndex = i
                    return true;
                }
            });

            setActiveModelIndex(modelIndex);
            setActiveModel(models[modelIndex]);
            setActiveFloorplanIndex(floorplanIndex);
            setFloorplan(models[modelIndex].floorplans[floorplanIndex].floorplan);
            setActiveConfiguration(models[modelIndex].floorplans[floorplanIndex].floorplan.configurations[0]);


            if (ref && ref.current) {
                setTimeout(() => {
                    const element = ref.current;
                    const topPos = element.getBoundingClientRect().top + window.pageYOffset;
                    const cssTopPadding = getStyle(element.parentNode, 'padding-top');
                    const cssTopMargin = getStyle(element.parentNode, 'margin-top');
                    
                    const topPadding = cssTopPadding.length > 0 ? parseInt(cssTopPadding) : 0
                    const topMargin = topPadding > 0 ? 0 : (cssTopMargin.length > 0 ? parseInt(cssTopMargin) : 0)

                    const isMobile = window.outerWidth < 940
                    const heightOfNav = 0 // isMobile ? 71 : 87 // not needed now
                    const heightOfSubNav = isMobile ? 48.5 : 53

                    // element.scrollIntoView({ behavior: 'smooth' });

                    console.log('element.parentNode', element.parentNode, {topPos, heightOfNav,heightOfSubNav,topMargin, topPadding})

                    window.scrollTo({
                        top: topPos - heightOfNav - heightOfSubNav - topMargin - topPadding, // scroll so that the element is at the top of the view
                        behavior: 'smooth' // smooth scroll
                    })
                }, 500);
            }
        }
    }, []);

    const floorplanCta = floorplan ? '/get-a-quote?' + qs.stringify({items: [floorplan.ctaObj]}) : '/get-a-quote';

    const tableSpecs = (floorplan && floorplan.specsFeatures && floorplan.specsFeatures.specs) ? floorplan.specsFeatures.specs.filter(item => {
        return item.value.toString() !== '0'
    }) : []

    const handleCalcLaunch = (e) => {

        if (e) {
            e.preventDefault();
        }

        setCalcBannerModal(!calcBannerModal);
        
    };

    console.log('activeM', {props, activeModel, floorplan});

    return (
        <Container background={background} colourTheme={colourTheme} ref={ref}>
            {(floorplan && floorplan.specsFeatures) && 
                <Modal
                    isOpen={modal}
                    onClose={() => openModal(false)}
                    // overlayClassname={classes.modalOverlay}
                    innerClassname={classes.modalInner}
                    closeClassname={classes.modalClose}
                >   
                        <SpecsTable
                            {...floorplan.specsFeatures.modal}
                            background={colourTheme ==='dark' || background === 'black' ? 'black' : 'white'}
                            rangeId={rangeId}
                            seriesId={seriesId}
                            uri={uri}
                        />
                </Modal>
            }
            {(calculatorModal && countryProps && countryProps.countryCode.toLowerCase() === 'au') &&
                <CalculatorBannerModal 
                    open={calcBannerModal}
                    onModalClose={() => setCalcBannerModal(false)}
                    bannerContent={calculatorModal}
                    make="Jayco" // Jayco
                    price={price + (activeConfiguration && activeConfiguration.additionalPrice ? parseInt(activeConfiguration.additionalPrice) : 0)}
                    model={props.rangeTitle} // All Terrain
                    variant={floorplan?.title || ''} // JPOD.SP-MY23 or should it be 16ft?
                />
            }
            {pricingModal &&
                <PostcodePopup
                    open={true}
                    onSubmit={(postcode) => {
                        const key = pricingKey ? pricingKey : getPriceKey(postcode);
                        setPricingKey(key);
                        setPricingModal(false);
                    }}
                    onClose={() => {
                        setPricingKey('priceAUNSW');
                        setPricingModal(false);
                        const data = {
                          postcode: 2000
                        }
                        localStorage.setItem('userLocation', JSON.stringify(data));
                    }}
                />
            }
            <Grid container direction={'row'}>
                <Grid size={12}>
                    {preTitle &&
                        <Box px={2}>
                            <Text variant="subTitle" colour={"vividBlue"} uppercase="true" align="center">{preTitle}</Text>
                        </Box>
                    }
                    {title &&
                        <Box px={2}>
                            <Text variant="h2" weight={800} colour={mainFontColour} uppercase="true" align="center">{title}</Text>
                        </Box>
                    }
                    <Box px={2}>
                        <TabsContainer>
                        
                            {(models && models.length > 1) &&
                                <TabItem>
                                    <Text variant="body1" colour={mainFontColour} align="center" element="div"><p>Select a model</p></Text>
                                    <TabsCurved 
                                        variant='standard'
                                        background={colourTheme}
                                        activeIndex={activeModelIndex}
                                        data={models.map(item => {
                                            return {
                                                ...item,
                                                title: item.name
                                            }
                                        })}
                                        
                                        neverNative={true}
                                        onChange={(e, item) => {
                                            // setActiveFloorplan(floorplans[e])
                                            // if (activeModel.floorplans.length !== models[e].floorplans.length && !activeModel.floorplans[e].floorplan)

                                            // if model has different number of floorplans, get the closest one (only should apply to last)
                                            const curFloorplanIndex = findIndex(activeModel.floorplans, (i) => i.floorplan.floorplanId === floorplan.floorplanId);
                                            // const newFloorplanIndex = findIndex(models[e].floorplans, (i) => i.floorplanId === floorplan.floorplanId);

                                            if (!models[e].floorplans[curFloorplanIndex]) {
                                                const lastIndex = models[e].floorplans.length - 1;
                                                setActiveFloorplanIndex(lastIndex);
                                                setFloorplan(models[e].floorplans[lastIndex].floorplan);
                                                setActiveConfiguration(models[e].floorplans[lastIndex].floorplan.configurations[0]);
                                            } else {
                                                setFloorplan(models[e].floorplans[curFloorplanIndex].floorplan);
                                                setActiveConfiguration(models[e].floorplans[curFloorplanIndex].floorplan.configurations[0]);
                                            }
                                            setActiveModelIndex(e);
                                            setActiveModel(models[e]);
                                        }}
                                        // background={background}
                                    />
                                </TabItem>
                            }
                            {(activeModel.floorplans && activeModel.floorplans.length > 1) &&
                            
                                    <TabItem>
                                        <Text variant="body1" colour={mainFontColour} align="center"><p>Select a floorplan</p></Text>
                                        <TabsCurved 
                                            background={colourTheme}
                                            variant='standard'
                                            activeIndex={activeFloorplanIndex}
                                            neverNative={true}
                                            data={activeModel.floorplans.map(item => {
                                                return {
                                                    ...item,
                                                    title: item.name
                                                }
                                            })}                                    
                                            onChange={(e, item) => {
                                                console.log('activeModel', activeModel, e, item);
                                                setActiveFloorplanIndex(e);
                                                setFloorplan(activeModel.floorplans[e].floorplan);
                                                setActiveConfiguration(activeModel.floorplans[e].floorplan.configurations[0]);
                                            }}
                                            // background={background}
                                        />
                                    </TabItem>
                                
                            }
                        </TabsContainer>
                    </Box>
                </Grid>
            </Grid>
            <Grid container direction={'row'}>
                <Grid size={12}>
                    <Box px={2}>
                        <Hr />
                    </Box>
                </Grid>
            </Grid>
            <FloorplanContainer>
                <Grid container direction={'row'}>
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 8
                        }}>
                        <Box px={2}>
                            {activeConfiguration &&
                                <FloorplanImg>
                                    <ResponsiveImage 
                                        {...activeConfiguration.image} type={'png'} 
                                    />
                                </FloorplanImg>
                            }
                            {floorplan && floorplan.configurations && floorplan.configurations.length > 1 &&
                                <FloorplansText variant="body1" colour={mainFontColour}>
                                    Select a Floor Plan Configuration
                                </FloorplansText>
                            }
                        </Box>
                        <Floorplans length={floorplan && floorplan.configurations ? floorplan.configurations.length : 0}>
                            {floorplan && floorplan.configurations && floorplan.configurations.map(item => {
                                return (
                                    <FloorplanConfiguration 
                                        key={item.id} 
                                        badge={item.badge && item.badge} 
                                        onClick={() => setActiveConfiguration(item)} 
                                        active={item.id === activeConfiguration.id} 
                                        background={background ? background : ''} 
                                        colourTheme={colourTheme ? colourTheme : ''}
                                    >
                                        <FloorplanConfigurationIcons>
                                            <Adults>
                                                {Array.apply(null, {length: item.sleepsAdults}).map((i, index) => {
                                                    return(
                                                        <Adult>
                                                            <ReactSVG key={item.id + index} src={floorplanAdult} />
                                                        </Adult>
                                                    )
                                                })}
                                            </Adults>
                                            {(item.sleepsChildren > 0) &&
                                            <>
                                                <Plus>
                                                    <ReactSVG src={plusSvg} />
                                                </Plus>
                                                <Children active={item.id === activeConfiguration.id} background={background} theme={colourTheme}>
                                                    {Array.apply(null, {length: item.sleepsChildren}).map((i, index) => {
                                                        return(
                                                            <Child >
                                                                <ReactSVG key={item.id + index} src={floorplanChild} />
                                                            </Child>
                                                        )
                                                    })}
                                                </Children>
                                            </>
                                            }
                                                {(item.sleepsAdditional > 0) &&
                                                <>
                                                
                                                    <Plus>
                                                        <ReactSVG src={plusSvg} />
                                                    </Plus>
                                                    <Children active={item.id === activeConfiguration.id} background={background} theme={colourTheme}>
                                                        {Array.apply(null, {length: item.sleepsAdditional}).map((i, index) => {
                                                            return(
                                                                <Child opacity={true}>
                                                                    <ReactSVG key={item.id + index} src={floorplanChild} />
                                                                </Child>
                                                            )
                                                        })}
                                                    </Children>
                                                </>
                                            }
                                        </FloorplanConfigurationIcons>
                                        <FloorplanConfigurationText active={item.id === activeConfiguration.id} background={background} theme={colourTheme}>
                                            {item.size &&
                                                <strong>{item.size}</strong>
                                            }
                                            {item.shape &&
                                                <p>{item.shape}</p>
                                            }
                                        </FloorplanConfigurationText>
                                    </FloorplanConfiguration>
                                )
                            })}
                        </Floorplans>
                        <Box px={2}>
                            <FloorplansText variant="body1" colour={mainFontColour} small>
                                {`Sleeps ${activeConfiguration.sleepsAdults} adults${activeConfiguration.sleepsChildren ? ` + ${activeConfiguration.sleepsChildren} children` : ''}${activeConfiguration.sleepsAdditional ? ` + ${activeConfiguration.sleepsAdditional} additional`: ''}`}
                            </FloorplansText>
                            {floorplan && floorplan.configurations && floorplan.configurations.length > 1 &&
                                <FloorplansDiscalimer variant="body1" colour={mainFontColour}>
                                    Floorplan variation may affect RRP. Please consult your local dealer.
                                </FloorplansDiscalimer>
                            }

                        </Box>
                    </Grid>
                    <Grid
                        size={{
                            xs: 12,
                            md: 6,
                            lg: 4
                        }}>
                        {floorplan && floorplan.title &&
                            <Box px={2}>
                                <FloorplanContent>
                                {
                                    (floorplan.image || floorplan.logo) &&
                                    <FloorplanImage>
                                        {floorplan.image &&
                                            <FloorplanImageImg>
                                                <ResponsiveImage 
                                                    {...floorplan.image}
                                                />
                                            </FloorplanImageImg>
                                        }
                                    </FloorplanImage>
                                }
                                    <Text variant="h3" element="h4" colour={mainFontColour} uppercase={true} weight={800} align="left">{floorplan.title}</Text>
                                    {(price > 0 && floorplan.hidePrice !== true && !priceLoading) ?
                                        <>
                                            <Text variant="body1" colour={mainFontColour} align="left">{props.type === 'campervan' ? 'Drive' : 'Tow'} away from</Text>
                                            <Text variant="h3" element="h4" colour={mainFontColour} uppercase="true" weight={800} align="left">${toPrice((price + (activeConfiguration.additionalPrice ? parseInt(activeConfiguration.additionalPrice) : 0)))}<sup>*</sup></Text>
                                            {(financePerWeek > 0) &&
                                                <Text variant="body1" colour={mainFontColour} align="left">Finance from <strong>${toPrice(parseInt(financePerWeek))} </strong> per week^</Text>
                                            }
                                        </>
                                    : null}
                                    
                                    {(calculatorModal && calculatorModal.buttonText && countryProps && countryProps.countryCode.toLowerCase() === 'au') &&
                                    <CalculatorLink>
                                        <IconLink 
                                            svg={''}
                                            link={{
                                                title: calculatorModal.buttonText
                                            }}
                                            colour={colourTheme === 'dark' ? 'white' : 'black'}
                                            onClick={handleCalcLaunch}
                                        />
                                  
                                    </CalculatorLink>
                                    }

                                    <Hr />
                                    {cta &&
                                        <CtaLink>
                                            <NextLink href={cta.href && cta.href !== '#' ? cta.href : floorplanCta}  target={cta.target}>
                                                {/* <a> */}
                                                    <Cta inline>
                                                        {cta.title}
                                                    </Cta>
                                                {/* </a> */}
                                            </NextLink>
                                        </CtaLink>
                                    }
                                    {/* {financeLink &&
                                        <Link>
                                            <IconLink 
                                                svg={calculatorSvg}
                                                link={financeLink}
                                                colour={colourTheme === 'dark' ? 'white' : 'black'}
                                            />
                                        </Link>
                                    } */}
                                    {brochureLink &&
                                        <Link>
                                            <IconLink 
                                                svg={brochuresSvg}
                                                link={brochureLink}
                                                colour={colourTheme === 'dark' ? 'white' : 'black'}
                                            />
                                        </Link>
                                    }
                                    
                                </FloorplanContent>
                                
                            </Box>
                        }
                    </Grid>
                </Grid>
                <Specs>
                    <Grid container direction={'row'} justifyContent={'flex-start'}>
                        <Grid
                            size={{
                                xs: 12,
                                md: 6,
                                lg: 8
                            }}>
                            <Box px={2}>
                            {(floorplan && floorplan.specsFeatures) && 
                                <>
                                    <Text variant="subTitle" uppercase weight={700} colour={mainFontColour}>Specifications</Text>
                                    
                                    <SpecsFeatures colour={colourTheme === 'dark' ? 'white' : 'black'} odd={tableSpecs.length % 2  == 0 ? false : true}>
                                        {tableSpecs.map(item => {
                                            return (
                                                <SpecsFeaturesItem key={item.item} background={background}>
                                                    <SpecsFeaturesTitle>{item.title}</SpecsFeaturesTitle>
                                                    <SpecsFeaturesValue>{item.value}</SpecsFeaturesValue>
                                                </SpecsFeaturesItem>
                                            ) 
                                        })}
                                    </SpecsFeatures>
                                    <CtaContainer colorTheme={colourTheme}>
                                        <Cta 
                                            outline
                                            uppercase
                                            onClick={handleLaunchModal}
                                        >
                                            View all SPECS & FEATURES
                                        </Cta>
                                    </CtaContainer>
                                </>
                                }
                            </Box>
                        </Grid>
                    </Grid>
                </Specs>
            </FloorplanContainer>
            {(floorplan && floorplan.link360) &&
                <Container360>
                     {(link360PreTitle || link360Title) &&
                        <Grid container spacing={0} direction={'row'}>    
                            <Grid size={12}>   
                                <Container360Titles>
                                    <Box px={2}>
                                    {link360PreTitle &&
                                        <Text variant="subTitle" colour={'vividBlue'} uppercase={true} align="center">
                                            {link360PreTitle}
                                        </Text>
                                    }
                                    {link360Title &&
                                        <Text element="h3" variant="h3" weight={800} colour={mainFontColour} uppercase={true} align="center">
                                            {ReactHtmlParser(link360Title)}
                                        </Text>
                                    }
                                    </Box>
                                </Container360Titles>
                            </Grid>
                        </Grid>
                    }
                    
                    <IFrameContainer ref={iframeRef} >
                        {iframeInView &&
                            <iframe scrolling="no" src={floorplan.link360 + '&play=1&qs=1&wh=0&brand=1&dh=0&title=0&search=0'} />
                        }
                    </IFrameContainer>
                </Container360>
            }
        </Container>
    );
}

Floorplan.propTypes = {
}

export default Floorplan
